// ─── DESIGN TOKENS — By Julie Déco ───────────────────────────────────────────
// Source unique. Importer ici dans tous les composants.

export const C = {
  black:     '#0a0a0a',
  white:     '#ffffff',
  gold:      '#C9A84C',
  cream:     '#fafaf8',
  muted:     '#6B6B64', // 4.8:1 sur blanc — WCAG AA ✓
  dim:       '#444440',
  ghostLine: 'rgba(201,168,76,0.18)',
};

export const F = {
  serif: "'Cormorant Garamond', Georgia, serif",
  sans:  "'Jost', 'Helvetica Neue', sans-serif",
};
